export enum ModalType {
    LOGIN = 'login',
    REGISTER = 'register',
    CART_INVOICE_DETAILS = 'cart_invoice_details',
    USER_INVOICE_DETAILS = 'user_invoice_details',
    CART_TICKET_PERSONAL_DETAILS = 'cart_ticket_personal_details',
    TICKET_TYPE_EDIT = 'ticket_type_edit',
    STANDING_SECTOR_TICKET_SELECTOR = 'standing_sector_ticket_selector',
    SPECIAL_ACCESS_MODAL = 'special_access_modal',
}